import { Button, Paper, Step, StepContent, StepLabel, Stepper, Typography } from '@mui/material';
import React from 'react';
import SplashScreenModal from '../common/components/SplashScreenModal';
import I18n, { useI18n } from '../common/i18n/I18n';
import { V } from '../common/Layout';
import { useStyling } from '../common/Theme';
import { RESOURCE_TYPE } from '../resource/common/resourceConstants';

interface CrewHireModalProps {
    onAddClicked: () => void;
    onSplashScreenClose: (isResourceModalOpen?: boolean) => void;
    splashScreenVisible: boolean;
    selectedResType: string;
}

export default ({ onAddClicked, onSplashScreenClose, splashScreenVisible, selectedResType }: CrewHireModalProps) => {
    const { theme } = useStyling();
    const isPeopleType = [RESOURCE_TYPE.crew, RESOURCE_TYPE.cast, RESOURCE_TYPE.corporate].includes(selectedResType);
    // If title is useI18n we get warnings in console, while subtext needs to be i18n because of getFormattedSubText
    const LIST_TEXT = [
        {
            title: <I18n token={isPeopleType ? 'form.crew.hire.subtitle.one' : 'form.supplier.hire.subtitle.one'} />,
            subtext: useI18n(isPeopleType ? 'form.crew.hire.subtext.one' : 'form.supplier.hire.subtext.one')
        },
        {
            title: <I18n token="form.splash.screen.hire.subtitle.two" />,
            subtext: useI18n('form.splash.screen.hire.subtext.two')
        },
        {
            title: (
                <I18n token={isPeopleType ? 'form.crew.hire.subtitle.three' : 'form.supplier.hire.subtitle.three'} />
            ),
            subtext: useI18n(isPeopleType ? 'form.crew.hire.subtext.three' : 'form.supplier.hire.subtext.three')
        },
        {
            title: <I18n token={isPeopleType ? 'form.crew.hire.subtitle.four' : 'form.supplier.hire.subtitle.four'} />,
            subtext: useI18n(isPeopleType ? 'form.crew.hire.subtext.four' : 'form.supplier.hire.subtext.four')
        }
    ];

    const getFormattedSubText = (subText, index) => {
        return (
            <span key={index}>
                {subText}
                {index === 3 && (
                    <span style={{ fontWeight: '600', fontStyle: 'italic' }}>
                        <I18n token="form.splash.screen.hire.subtext.soon" />
                    </span>
                )}
            </span>
        );
    };

    return (
        <SplashScreenModal onClose={() => onSplashScreenClose()} open={splashScreenVisible}>
            <Paper
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'start',
                    padding: 5,
                    gap: 2,
                    width: '500px'
                }}
            >
                <Typography variant="h4" sx={{ fontWeight: 'bold', color: theme.palette.secondary.main }}>
                    <I18n token={isPeopleType ? 'form.crew.hire.title' : 'form.supplier.hire.title'} />
                </Typography>
                <V gap={4}>
                    <Stepper
                        orientation="vertical"
                        sx={{
                            '& .MuiStepConnector-root': {
                                contentVisibility: 'hidden'
                            },
                            '& .MuiStepLabel-root': {
                                padding: 0
                            },
                            '& .MuiStepContent-root .MuiTypography-root': {
                                paddingBottom: 2
                            }
                        }}
                    >
                        {LIST_TEXT.map((item, index) => (
                            <Step key={index} active={true}>
                                <StepLabel>
                                    <Typography fontSize={16} fontWeight="bold">
                                        {item.title}
                                    </Typography>
                                </StepLabel>
                                <StepContent>
                                    <Typography fontSize={12}>{getFormattedSubText(item.subtext, index)}</Typography>
                                </StepContent>
                            </Step>
                        ))}
                    </Stepper>
                    <Button
                        variant="contained"
                        sx={{ width: 'fit-content', alignSelf: 'center', position: 'relative' }}
                        onClick={() => {
                            onAddClicked();
                            onSplashScreenClose(true);
                        }}
                    >
                        <I18n token="form.splash.screen.hire.button" />
                    </Button>
                </V>
            </Paper>
        </SplashScreenModal>
    );
};
